// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__1V8N5","header":"Login_header__2IqwW","avatar":"Login_avatar__2bzV6"};